/*
 * Shared clear (×) button wiring for search inputs (.ls-search-clear).
 *
 * Toggles the button with the input's content and empties the input on
 * click; what happens after a clear differs per consumer (the live search
 * closes its results panel and reloads, the listing toolbar re-submits),
 * so that part is passed in as `onClear`.
 *
 * Loaded before live-search.js / finder.js in the bundle (gulpfile.js).
 */
window.lsWireSearchClear = function (input, clearBtn, onClear) {
    if (!input || !clearBtn) return;
    clearBtn.addEventListener('click', function () {
        input.value = '';
        clearBtn.hidden = true;
        onClear();
    });
    input.addEventListener('input', function () { clearBtn.hidden = !input.value; });
};
